const footerColumns = [
  {
    title: "站内导航",
    links: [
      { label: "精选推荐入口", href: "#entries" },
      { label: "分类专区", href: "#categories" },
      { label: "合集大全汇总", href: "#collections" },
      { label: "导航站热榜", href: "#rank" },
    ],
  },
  {
    title: "整理方式",
    links: [
      { label: "按题材归好", href: "#categories" },
      { label: "按更新时间排", href: "#entries" },
      { label: "按热度重排", href: "#rank" },
      { label: "按周回看归档", href: "#collections" },
    ],
  },
  {
    title: "使用帮助",
    links: [
      { label: "四步挑入口", href: "#guide" },
      { label: "入口校验说明", href: "#guide" },
      { label: "常见问题", href: "#faq" },
      { label: "整理记录速览", href: "#top" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-secondary-100">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1fr] lg:gap-10">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-door-open-line text-lg" />
              </span>
              <span className="font-heading text-base font-bold text-foreground-950">黑料入口</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-6 text-foreground-700">
              推荐、合集、大全、汇总一次整理好的导航站式入口列表。热门黑料与吃瓜站点按类归好，点开就能按需挑着看。
            </p>
            <div className="mt-5 flex flex-wrap items-center gap-2">
              <span className="rounded-full border border-secondary-300/70 bg-secondary-50 px-3 py-1 text-[11px] text-secondary-900">
                每日整理
              </span>
              <span className="rounded-full border border-secondary-300/70 bg-secondary-50 px-3 py-1 text-[11px] text-secondary-900">
                入口校验
              </span>
              <span className="rounded-full border border-secondary-300/70 bg-secondary-50 px-3 py-1 text-[11px] text-secondary-900">
                按类归好
              </span>
            </div>
          </div>

          {footerColumns.map((column) => (
            <div key={column.title}>
              <h4 className="font-heading text-sm font-bold text-foreground-950">
                <a href="#top" className="cursor-pointer">
                  {column.title}
                </a>
              </h4>
              <ul className="mt-4 flex flex-col gap-2.5">
                {column.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="cursor-pointer text-sm text-foreground-600 transition-colors hover:text-primary-600"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-secondary-300/60 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-600">© 2026 黑料入口 · 导航站整理 · 仅供信息导航参考</p>
          <p className="text-xs text-foreground-500">页面内容为静态展示，入口跳转与外部站点内容与其各自运营方相关。</p>
        </div>
      </div>
    </footer>
  );
}